import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchServices } from '../rtk/slices/services-slice'
import { fetchColor } from '../rtk/slices/color-slice'
import { fetchProjects } from '../rtk/slices/projects-slice'

function All_certificates () {
    const color = useSelector((state) => state.color.color);
    const dispatch = useDispatch();
    const projects = useSelector((state) => state.projects.projects);
    const [servicesSearch, setServicesSearch] = useState(projects);

    const filterService = (searchKeyword) => {
        const updateData = projects.filter((service) => service.title.includes(searchKeyword));
        setServicesSearch(updateData)
    }

    if (color.length > 0) {
        let inputString = color[0].color;
        let filteredValue = inputString.replace(/[^0-9,]/g, '');

        // تعيين قيمة المتغير --main-color في :root
        const root = document.documentElement;
        root.style.setProperty("--main-color", `${filteredValue}`);
    }

    useEffect(() => {
        // fetch color
        dispatch(fetchColor());

        // fetch services
        dispatch(fetchProjects())

    }, [])

    return (
        <section className='projects ' id='projects'>
            <div className="container">
                <h2 className="title">
                    <span>المشاريع</span>
                    <p>المشاريع</p>
                </h2>
                <div className="certificates">
                    <form style={{ marginTop: "3rem" }}>
                        <div className="input-box">
                            <div className="input-field">
                                <input className='myInput' name='name' type="text" onChange={(e) => filterService(e.target.value)} placeholder='اسم المشروع' required />
                                <div className="icon"><i class="fa fa-search"></i></div>
                            </div>
                        </div>
                        {/* <div class="btn-box btns"><button class="button type1"><span class="btn-txt"><a>بحث</a></span></button></div> */}
                    </form>
                </div>

                <div className="cards">

                    {servicesSearch.length < 1 ?
                        projects.map((project, index) => {
                            return (
                                <a target='_blank' href={`${project.url}`} className="card" key={project.id}>
                                    <h2>{index + 1}</h2>
                                    <h3>{project.title}</h3>
                                    <p>{project.description}</p>
                                </a>
                            )
                        })
                        :
                        servicesSearch.map((project, index) => {
                            return (
                                <a target='_blank' href={`${project.url}`} className="card" key={project.id}>
                                    <h2>{index + 1}</h2>
                                    <h3>{project.title}</h3>
                                    <p>{project.description}</p>
                                </a>
                            )
                        })
                    }

                </div>

                <Link className='exit' to={`/`}>
                    <div class="menu active">
                        <span class="span1"></span>
                        <span class="span2"></span>
                        <span class="span3"></span>
                    </div>
                </Link>
            </div>
        </section>
    )
}

export default All_certificates
